import { SET_APOLLO_CLIENT } from './constants'
import {
    SetApolloClientAction,
    GraphqlActionType,
    INITIAL_STATE_TYPE,
} from './types'

export const INITIAL_STATE: INITIAL_STATE_TYPE = {
    apolloClient: null,
}

export const reducer = (state = INITIAL_STATE, action: GraphqlActionType) => {
    switch (action.type) {
        case SET_APOLLO_CLIENT: {
            const castAction = action as SetApolloClientAction

            return {
                ...state,
                apolloClient: castAction.client,
            }
        }
        default:
            return state
    }
}
